import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import HeatRanking from "@/pages/home/components/HeatRanking";
import TopicCollections from "@/pages/home/components/TopicCollections";
import TimeBoardTabs from "@/pages/home/components/TimeBoardTabs";
import TagTower from "@/pages/home/components/TagTower";
import EditorPicks from "@/pages/home/components/EditorPicks";
import StatsStrip from "@/pages/home/components/StatsStrip";
import SubscribeCta from "@/pages/home/components/SubscribeCta";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <HeatRanking />
        <TopicCollections />
        <TimeBoardTabs />
        <TagTower />
        <StatsStrip />
        <EditorPicks />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}